import { generateEndpoint } from "@/utils/utils";
import type { PaginatedResponse } from "@/v2/queries/types";
import { apiClientJSON } from "../apiClient";

export interface Lock {
  id: number;
  code: string;
  brand: string;
  battery: number | null;
  status: string;
  type: string;
  vehicle?: {
    name?: string;
    code?: string;
    lastSeenOnline?: string | null;
    dock?: {
      code?: string;
    };
    city?: {
      name?: string;
    };
  };
}

export interface LockListParams {
  page?: number;
  search?: string;
  sort?: string;
  filter?: string;
  size?: number;
}

export const getLocksAPI = (
  params: LockListParams = {}
): Promise<PaginatedResponse<Lock>> => {
  const { page = 0, search = "", sort = "", filter = "", size = 10 } = params;
  const endpoint = generateEndpoint(
    `/station-service/dashboard/locks?size=${size}`,
    page,
    search,
    sort,
    filter
  );
  return apiClientJSON.get(endpoint).then((r) => r.data);
};

export const unlockLockAPI = (id: number): Promise<void> => {
  return apiClientJSON
    .post(`/station-service/dashboard/locks/${id}/unlock`)
    .then((r) => r.data);
};
